import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {SvgAssets} from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';

const Pagination = (props) => {

  const [disabled, setDisabled] = useState(true);  
  var pageNumber = props.currentPage
  var pageSize = props.size
  let currentPage = (pageNumber - 1) * pageSize
  let pages = []
  for (var i = currentPage; i < (pageSize + currentPage); i++) {
    if (i + 1 <= props.totalPage.length)  
      pages.push(i + 1)

  }

  return (
    <div className='pagination'>
      <button className='btn-icon'
      type="button"
      onClick={() => props.event(props.current - 1, pages[0]==props.current , "minus")}
      disabled={props.current == 1}
      >
        <SvgAssets icon="icon-left" fill={props.current == 1 ? c.celeste : c.azulClaro} />
      </button>
      <div>
        {pages.map((item, index) => {
          return (
            <span key={index}
            className={props.current == item ? "active": ""}
            onClick={props.current == item ? () => {} : () => props.event(item, false)}
            >{item}</span>
          )
        })
        } 
      </div>
      <button className='btn-icon'
      type="button"
      onClick={() => props.event(props.current + 1, pages[props.size-1]==props.current, "add")}
      disabled={props.current == props.totalPage.length}
      >
        <SvgAssets icon="icon-right" fill={props.current == props.totalPage.length ? c.celeste : c.azulClaro} />
      </button>
    </div>
  );
}

export default Pagination;